import React, { useEffect, useState } from 'react';

const FacebookShareButton = ({ url, quote }) => {
  const [sdkLoaded, setSdkLoaded] = useState(false);

  useEffect(() => {
    // Load Facebook SDK
    const loadFbSdk = () => {
      if (window.FB) {
        setSdkLoaded(true);
        return;
      }

      window.fbAsyncInit = function () {
        window.FB.init({
          appId: '197122389301957',
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v20.0',
        });
        setSdkLoaded(true);
      };

      const script = document.createElement('script');
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      script.async = true;
      script.onload = () => {
        if (window.FB) {
          window.FB.init({
            appId: '1258840198573212',
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v21.0',
          });
          setSdkLoaded(true);
        }
      };
      document.body.appendChild(script);
    };

    loadFbSdk();
  }, []);

  const handleClick = () => {
    if (!sdkLoaded || !window.FB) {
      alert('Facebook SDK not loaded yet.');
      return;
    }

    window.FB.ui(
      {
        method: 'share',
        href: url,
        quote: quote,
      },
      response => {
        if (response && !response.error_message) {
          console.log('Posting completed.');
        } else {
          console.log('Error while posting.');
        }
      }
    );
  };
  return (
    <button onClick={handleClick}>
      <img src={process.env.NEXT_PUBLIC_WEPRODIGI + '/uploads/images/blog/fb.svg'} width={12} height={25} alt="share fb" />
    </button>
  );
};

export default FacebookShareButton;
